import http from "./httpService";

export default async function generateNewPassword(formData: FormData) {
    try {
        const response = await http.post("/user/Forget_password_Newpassword_generation", formData);
        return response.data
    } catch(err: any) {
        return {err: err?.response?.data}
    }
}